module.exports = __webpack_public_path__ + "d75af5412d10a072b457cd649ac2ee3f.png";